import React from 'react';
import useIubenda from '../hooks/useIubenda';

/**
 * Component providing UI controls for privacy settings
 */
const PrivacyControls = () => {
  const { isIubendaLoaded, openPreferences, hasInteractedWithBanner, showConsentBanner } = useIubenda();

  return (
    <div className="privacy-controls">
      {isIubendaLoaded ? (
        <div className="flex flex-col">
          <button
            onClick={openPreferences}
            className="text-green-700 hover:text-green-900 font-medium"
            aria-label="Impostazioni Privacy"
          >
            Impostazioni Privacy
          </button>
          {/* {!hasInteractedWithBanner() && (
            <button
              onClick={showConsentBanner}
              className="text-green-700 hover:text-green-900 mt-2 font-medium"
              aria-label="Gestione Cookie"
            >
              Gestione Cookie
            </button>
          )} */}
        </div>
      ) : (
        <div className="text-gray-500 text-sm">Caricamento Privacy...</div>
      )}
    </div>
  );
};

export default PrivacyControls;

